(function () {
  // Smooth scroll for in-page anchors with sticky-header offset
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href');
    if (id.length < 2) return;
    var target = document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    var header = document.querySelector('.mv-header');
    var offset = header ? header.offsetHeight + 8 : 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset, behavior: reduce ? 'auto' : 'smooth' });
  });
})();

// Product listing galleries
function mvInitGalleries(root) {
  root.querySelectorAll('[data-mv-gallery]').forEach(function (gal) {
    if (gal.dataset.mvReady) return;
    gal.dataset.mvReady = '1';
    var track = gal.querySelector('[data-mv-track]');
    if (!track) return;
    var slides = track.children;
    var thumbs = gal.querySelectorAll('[data-mv-thumb]');
    function current() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.mvThumb); }); });
    var prev = gal.querySelector('[data-mv-prev]'), next = gal.querySelector('[data-mv-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(current() - 1);
      if (e.key === 'ArrowRight') go(current() + 1);
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = current();
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      });
    });
  });
}
mvInitGalleries(document);
document.addEventListener('shopify:section:load', function (e) { mvInitGalleries(e.target); });
